<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">

         <v-menu
          ref="menuDate"
          v-model="menuDate"
          :close-on-content-click="false"
          :return-value.sync="document.date"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="document.date"
              label="Data"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="document.date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuDate = false">Cancel</v-btn>
            <v-btn text color="primary"
              @click="$refs.menuDate.save(document.date)">OK</v-btn>
          </v-date-picker>
        </v-menu>

        <v-text-field label="Nr. Factura:" v-model="document.invoiceNumber">
        </v-text-field>

        <v-text-field label="Cumparator:"
          v-model="document.name"
          :rules="requiredRules"
          required>
        </v-text-field>

        <v-text-field label="C.I.F.:"
          v-model="document.cnp"
          :rules="requiredRules"
          required>
        </v-text-field>

        <v-text-field label="Judet:"
          v-model="document.county"
          :rules="requiredRules"
          required>
        </v-text-field>

        <v-text-field label="Street:"
          v-model="document.street"
          :rules="requiredRules"
          required>
        </v-text-field>

        <v-text-field label="Localitate / Sector:" v-model="document.addressDetails">
        </v-text-field>

        <v-text-field label="Nr.Ord.Reg.Com:"
          v-model="document.nrRegCom">
        </v-text-field>

        <v-text-field label="Suma de:"
          v-model="document.amount"
          :rules="requiredNumberRules"
          required
          @change="convertToWords()">
        </v-text-field>

        <v-text-field label="Suma in litere:"
          v-model="document.amountInLetters">
        </v-text-field>

        <v-text-field label="Reprezentand:"
          v-model="document.reason"
          :rules="requiredRules"
          required>
        </v-text-field>

        <v-text-field label="Casier:"
          v-model="document.cashier"
          :rules="requiredRules"
          required>
        </v-text-field>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
          <v-btn @click="preview" color="primary">Previzualizare</v-btn>
        </div>
      </v-form>

    </v-flex>
  </v-layout>
</template>

<script>
import { busEvent } from '../../main';
import convertNumberInWords from '../../utils/convert-to-letters';

export default {
  data() {
    return {
      valid: true,
      menuDate: false,
      document: {
        type: 'receipt',
        date: new Date().toISOString().substr(0, 10),
        nrRegCom: '',
        name: '',
        cnp: '',
        county: '',
        street: '',
        addressDetails: '',
        amount: 0,
        amountInLetters: '',
        reason: '',
        cashier: 'ROBERT STEFANESCU',
        invoiceNumber: 0,
        invoiceId: 0,
      },
      requiredRules: [
        (element) => {
          if (element.trim() === '') return 'Campul trebuie completat.';
          return true;
        },
      ],
      requiredNumberRules: [
        (element) => {
          if (element === 0) return 'Campul trebuie completat';
          return true;
        },
      ],
    };
  },
  async created() {
    const lastInvoice = await this.$store.dispatch('documents/getLastDocument', {
      documentType: 'invoice',
    });
    this.document.invoiceNumber = lastInvoice.number;
    if (lastInvoice.invoice) {
      this.document.nrRegCom = lastInvoice.invoice.nrRegCom;
      this.document.name = lastInvoice.invoice.name;
      this.document.cnp = lastInvoice.invoice.cnp;
      this.document.county = lastInvoice.invoice.county;
      this.document.street = lastInvoice.invoice.street;
      this.document.addressDetails = lastInvoice.invoice.addressDetails;
      this.document.amount = lastInvoice.invoice.price;
      const createdAt = new Date(lastInvoice.createdAt);
      const formattedDate = `${createdAt.getDate()}-${createdAt.getMonth() + 1}-${createdAt.getFullYear()}`;
      this.document.reason = `CVF REP ${lastInvoice.number}/${formattedDate}`;
      this.document.invoiceId = lastInvoice.invoice.id;
    }

    this.convertToWords();
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.$store.dispatch('documents/createCustom', {
          body: this.document,
        })
          .then(() => {
            busEvent.$emit('succesPopupCreated', 'Chitanta a fost creata');
            this.$router.back();
          });
      }
    },

    convertToWords() {
      this.document.amountInLetters = convertNumberInWords(this.document.amount);
    },
    async preview() {
      if (this.$refs.form.validate() && this.valid) {
        const response = await this.$store.dispatch('documents/previewCustom', {
          body: this.document,
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const fileName = response.headers['content-disposition'].match("filename='(.*)'");
        fileLink.setAttribute('download', fileName[1]);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
      }
    },
  },
};
</script>

<style>
</style>
